module.exports = __webpack_public_path__ + "static/media/14.30d5345f.gif";